module.exports = __webpack_public_path__ + "black_shipzone.png?fa3e5df6e79c17fb66c2b78ddbc42787";


//////////////////
// WEBPACK FOOTER
// ./assets/images/black_shipzone.png
// module id = 9
// module chunks = 0